import { SupportedLanguages } from '../../i18n/constants';
import type { LanguageOption } from '../LanguageSelect/types';

export const ENGLISH_LANGUAGE_OPTION: LanguageOption = {
  id: SupportedLanguages.EN,
  name: 'English',
  shortCode: SupportedLanguages.EN,
};
export const GERMAN_LANGUAGE_OPTION: LanguageOption = {
  id: SupportedLanguages.DE,
  name: 'Deutsch',
  shortCode: SupportedLanguages.DE,
};
export const SPANISH_LANGUAGE_OPTION: LanguageOption = {
  id: SupportedLanguages.ES,
  name: 'Español',
  shortCode: SupportedLanguages.ES,
};
export const FRENCH_LANGUAGE_OPTION: LanguageOption = {
  id: SupportedLanguages.FR,
  name: 'Français',
  shortCode: SupportedLanguages.FR,
};

export const LANGUAGE_OPTIONS_BY_ID: Record<SupportedLanguages, LanguageOption> = {
  [SupportedLanguages.EN]: ENGLISH_LANGUAGE_OPTION,
  [SupportedLanguages.DE]: GERMAN_LANGUAGE_OPTION,
  [SupportedLanguages.ES]: SPANISH_LANGUAGE_OPTION,
  [SupportedLanguages.FR]: FRENCH_LANGUAGE_OPTION,
};

export const LANGUAGES_OPTIONS: LanguageOption[] = Object.values(LANGUAGE_OPTIONS_BY_ID);
